export class EntityListAction {
  public name: string;
  public displayName: string;
  public iconName: string;
  public disabled: boolean;
  public Form_Component?: any;
  public requireSelectedrows?: boolean;
  public apiName: string;
  public areaName: string;
  public permission?: string | boolean = "Manage";
  public isModal?: boolean;
  public children?: EntityListAction[];
}
